export default {
    /**
     * Datos añadidos a data por el mixin:
     * - countryOptions: array con paises
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            formattedData: {},
            modifiedData: {},
            formatDataRules: () => ({})
        };
    },
    methods: {
        /**
         * Formatea el objeto `this.data` y setea el resultado en `this.formattedData`.
         *
         * Por defecto copia la misma estructura de data. Pero se pueden definir reglas específicas para cada campo.
         * Para ello se debe incluir el campo en el objeto `this.formatDataRules`, con un array donde:
         * - El último elemento será la función a ejecutar, que tendrá como parámetros el valor del campo
         * y el objeto formateado hasta el momento.
         * - Opcionalmente se puede renombrar el campo pasando un string
         *
         * ej:  'field1': [ 'field_1', (value) => value ]
         *
         */
        formatData() {
            const data = this.data;
            if (!data) {
                return;
            }
            const rules = this.formatDataRules();
            this.formattedData = Object.keys(data).reduce((acc, key) => {
                if (rules[key]) {
                    const rule = rules[key].pop();
                    let field = key;
                    if (rules[key].length > 0) {
                        field = rules[key].pop();
                    }
                    acc[field] = rule(data[key], acc);
                } else {
                    // deep copy in case it's an object
                    acc[key] = JSON.parse(JSON.stringify(data[key]));
                }
                return acc;
            }, {});
        },

        /**
         * Obtiene los datos pasando por la validación.
         * @return {*} `undefined` si no son validos
         */
        fetchValidatedData() {
            return this.validateData().then(valid => {
                if (valid) {
                    this.$store.dispatch('accountsStore/copyFiscalAddress', false);
                    return Array.isArray(this.data)
                        ? this.data.map((x, idx) => {
                            return Object.assign({}, x, this.modifiedData[idx]);
                        })
                        : Object.assign({}, this.data, this.modifiedData);
                } else {
                    return undefined;
                }
            });
        }
    },

    /**
     * Antes de montar el componente se formatea la info
     * `this.countryOptions`
     */
    beforeMount() {
        this.formatData();
    }
};
